import { ViewerModalFrame, ViewerModalSection, type ViewerModalTheme } from './ViewerModalFrame';

export interface Part {
  id: string;
  name: string;
  image: string;
  quantity: number;
}

interface PartsListModalProps {
  open: boolean;
  onClose: () => void;
  parts: Part[];
  title?: string;
  quantityLabel?: string;
  theme?: ViewerModalTheme;
}

export function PartsListModal({
  open,
  onClose,
  parts,
  title = 'Parts List',
  quantityLabel = 'Quantity',
  theme,
}: PartsListModalProps) {
  const t = {
    primaryTextColor: 'rgba(255, 255, 255, 0.95)',
    secondaryTextColor: 'rgba(255, 255, 255, 0.7)',
    accentColor: 'rgb(56, 189, 248)',
    borderColor: 'rgba(255, 255, 255, 0.1)',
    ...theme,
  };

  return (
    <ViewerModalFrame open={open} onClose={onClose} title={title} titleIcon="list" theme={theme}>
      <ViewerModalSection title={`${parts.length} part${parts.length !== 1 ? 's' : ''} required`} theme={theme}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.625rem' }}>
          {parts.map((part, index) => (
            <div
              key={index}
              style={{
                display: 'flex',
                border: `1px solid ${t.borderColor}`,
                borderRadius: '0.75rem',
                overflow: 'hidden',
                background: 'rgba(255, 255, 255, 0.02)',
              }}
            >
              <div
                style={{
                  width: '5rem',
                  flexShrink: 0,
                  backgroundColor: 'rgba(255, 255, 255, 0.04)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '0.5rem',
                }}
              >
                <img
                  src={part.image}
                  alt={part.name}
                  style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                />
              </div>
              <div style={{ flex: 1, padding: '0.75rem', minWidth: 0 }}>
                <div style={{ fontSize: '0.6875rem', color: t.secondaryTextColor, marginBottom: '0.125rem' }}>
                  {part.id}
                </div>
                <div style={{ fontWeight: 500, color: t.primaryTextColor, fontSize: '0.8125rem', marginBottom: '0.375rem' }}>
                  {part.name}
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ fontSize: '0.75rem', color: t.secondaryTextColor }}>{quantityLabel}</span>
                  <span style={{ fontWeight: 600, color: t.accentColor, fontSize: '0.8125rem' }}>{part.quantity}</span>
                </div>
              </div>
            </div>
          ))}
          {parts.length === 0 && (
            <p style={{ fontSize: '0.8125rem', color: t.secondaryTextColor, padding: '1.5rem 0.5rem', textAlign: 'center' }}>
              No parts available.
            </p>
          )}
        </div>
      </ViewerModalSection>
    </ViewerModalFrame>
  );
}
